/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import BackButton from "../back-button";
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import styled from "styled-components";

const StyledHr = styled.hr`
  background-color: #e0e0e0;
  border: none;
  height: 0.7px;
  margin-top: 32px;
  margin-bottom: 32px;
  margin-left: 0;
`;

export const SearchHeader = ({ title }: any) => {
  const { t } = useTranslation();

  return (
    <>
      {/* <Link to={ROUTES.DASHBOARD}>
        <BackButton label={t("Common.BackToLanding")} />
      </Link> */}
      <Typography variant="h1" style={{ marginTop: "10px" }}>
        {title}
      </Typography>
      <StyledHr></StyledHr>
    </>
  );
};
